module.exports = __webpack_public_path__ + "img/circle-white.8b8eab26.svg";